import { Cookies } from 'react-cookie';
import { WELCOME_TOOLTIP_COOKIE_NAME } from '../../config';
import moment from 'moment';

const hideToolTipCookie = name => {
  const opt = {
    expires: moment()
      .add(1, 'years')
      .toDate(),
  };

  new Cookies().set(name, false, opt, { path: '/account/people' });
};

const getWelcomeToolTipCookieStatus = () =>
  new Cookies().get(WELCOME_TOOLTIP_COOKIE_NAME) === undefined;

export { hideToolTipCookie, getWelcomeToolTipCookieStatus };
